// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__38Aan","modalForm":"UpgradeEpcsModal_modalForm__dIiw9","modalFooter":"UpgradeEpcsModal_modalFooter__2tcNu"};